<template>
  <v-row no-gutters>
    <v-col cols="auto" class="py-1">
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <div
            style="display: flex; align-items: center; margin-left: -6px"
            class="metric-title"
            v-bind="attrs"
            v-on="on"
          >
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                font-weight: 600;
                margin-right: 4px;
              "
            >
              {{ alert.metric.Title }}
            </span>
            <v-icon
              v-if="alert.metric.Can_Alert"
              small
              :color="hasActiveNotification ? 'hsl(0, 87%, 59%)' : 'black'"
              :style="{
                opacity: getBellIcon === 'mdi-bell-off-outline' ? '0.3' : '1',
              }"
            >
              {{ getBellIcon }}
            </v-icon>
          </div>
        </template>
        <span>{{ alert.metric.Description }}</span>
      </v-tooltip>
    </v-col>
    <v-spacer></v-spacer>
    <v-col
      cols="auto"
      class="py-1"
      style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
    >
      <span v-if="clearOnDisconnect && !isConnected">N/A</span>
      <span
        v-else
        class="copyable-value"
        @click="copyToClipboard(metricValue, alert.metric.Title)"
        >{{ displayValue }}</span
      >
    </v-col>
  </v-row>
</template>

<script>
import { formatMetricValue } from '../../services/metricService';

export default {
  props: {
    alert: {
      type: Object,
      default() {
        return {};
      },
    },
    node: {
      type: Object,
      default() {
        return {};
      },
    },
    isConnected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  computed: {
    hasActiveAlert() {
      const alerts = this.node?.alerts || [];
      const metricName = `${this.alert.metric.Module}/${this.alert.metric.Name}`;
      return alerts.some(
        (alert) => alert.metric === metricName && alert.condition !== ''
      );
    },
    isAlertSilenced() {
      const alerts = this.node?.alerts || [];
      const metricName = `${this.alert.metric.Module}/${this.alert.metric.Name}`;
      const matchingAlert = alerts.find(
        (alert) => alert.metric === metricName && alert.condition !== ''
      );
      return matchingAlert?.is_silenced || false;
    },
    hasActiveNotification() {
      const notifications = this.$store.state.notifications.notifications;
      const metricName = `${this.alert.metric.Module}/${this.alert.metric.Name}`;
      return notifications.some(
        (notification) =>
          notification.source === this.node.id &&
          notification.metric === metricName &&
          !notification.archived &&
          !notification.cleared
      );
    },
    getBellIcon() {
      if (this.hasActiveNotification) {
        return this.isAlertSilenced ? 'mdi-bell-sleep' : 'mdi-bell-ring';
      }
      if (this.hasActiveAlert) {
        return this.isAlertSilenced
          ? 'mdi-bell-sleep-outline'
          : 'mdi-bell-outline';
      }
      return 'mdi-bell-off-outline';
    },
    metricValue() {
      let value = this.$store.state.metrics.metric[this.alert.id];
      return formatMetricValue(
        this.alert.metric.Module,
        this.alert.metric.Name,
        value
      );
    },
    clearOnDisconnect() {
      return ['Latency'].includes(this.alert.metric.Name);
    },
    displayValue() {
      if (this.alert.metric.Name === 'SigningKeys') {
        return this.truncateSigningKey(this.metricValue);
      }
      return this.metricValue;
    },
  },
  methods: {
    copyToClipboard(text, fieldName) {
      if (!text) return;
      navigator.clipboard
        .writeText(text.toString())
        .then(() => {
          this.$emit('value-copied', `${fieldName} copied to clipboard`);
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    },
    truncateSigningKey(key) {
      if (!key || key.length <= 32) return key;
      return `${key.substring(0, 16)}...${key.substring(key.length - 16)}`;
    },
  },
};
</script>

<style>
.metric-title {
  cursor: help;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.metric-title:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
